<template>
  <div class="login-bridge">
    <a-spin size="large" tip="正在自动登录，请稍候..." />
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import { encryption, getEncryptedString } from '@/utils/encryption/aesEncrypt'
import { ACCESS_TOKEN, ENCRYPTED_STRING } from '@/store/mutation-types'
import { timeFix } from '@/utils/util'

export default {
  name: 'LoginBridge',
  mounted() {
    // 清除旧 token 确保重新登录
    Vue.ls.remove(ACCESS_TOKEN)
    this.handleAutoLogin()
  },
  methods: {
    ...mapActions(['AutoLogin']),
    async handleAutoLogin() {
      try {
        // 1. 获取加密参数 (key 和 iv)
        let encryptedString = Vue.ls.get(ENCRYPTED_STRING)
        if (!encryptedString) {
          encryptedString = await getEncryptedString()
        }

        // 2. 构造登录参数
        // 账号: ys, 密码: ys@123456
        const loginParams = {
          username: 'ys',
          password: encryption('ys@123456', encryptedString.key, encryptedString.iv),
          remember_me: true,
          captcha: '', // 中间页默认不带验证码，需后端配合或账号特殊权限
          checkKey: new Date().getTime()
        }

        console.log('LoginBridge: 执行自动登录', loginParams)

        // 3. 执行登录 Action
        this.AutoLogin(loginParams)
          .then((res) => {
            if (res.success) {
              this.$notification.success({
                message: '欢迎',
                description: `${timeFix()}，自动登录成功`,
              })
              this.$router.push({ path: '/' })
            } else {
              this.handleError(res.message || '登录失败')
            }
          })
          .catch((err) => {
            this.handleError(err.message || '登录接口异常')
          })
      } catch (err) {
        this.handleError(err.message || '加密初始化失败')
      }
    },
    handleError(msg) {
      this.$notification.error({
        message: '自动登录失败',
        description: msg,
        duration: 4,
      })
      // 失败后跳转到手动登录页面
      setTimeout(() => {
        this.$router.push({ path: '/user/login' })
      }, 1500)
    }
  }
}
</script>

<style scoped>
.login-bridge {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #f0f2f5;
}
</style>
